import { Box, Flex, Td, Text, useDisclosure } from '@chakra-ui/react'
import ModalChangeStock from '../../modals/ModalChangeStock'
import { FindItem } from './types'

export default function TdStock({
    item,
    stock,
    reload,
    status = 'normal'
}: {
    item: FindItem
    stock: number
    reload: () => void
    status?: 'critical' | 'low' | 'normal'
}) {
    const { isOpen, onOpen, onClose } = useDisclosure()

    // Determinar el color del círculo según el estado
    const getCircleColor = () => {
        switch (status) {
            case 'critical':
                return 'red.500'
            case 'low':
                return 'orange.400'
            default:
                return 'transparent'
        }
    }

    const showCircle = status !== 'normal'

    return (
        <Td>
            {isOpen ? (
                <ModalChangeStock
                    isOpen={isOpen}
                    onClose={onClose}
                    item={item}
                    reload={reload}
                />
            ) : null}
            <Flex align="center" gap={2}>
                <Text
                    onClick={onOpen}
                    as="span"
                    textDecoration={'underline'}
                    textColor={'blue'}
                    fontSize="sm"
                    cursor={'pointer'}
                >
                    {stock}
                </Text>
                {showCircle && (
                    <Box
                        w="10px"
                        h="10px"
                        borderRadius="50%"
                        bg={getCircleColor()}
                        flexShrink={0}
                    />
                )}
            </Flex>
        </Td>
    )
}
